import React from 'react';

const StatCard = ({ title, value, icon, color, delay = 0 }) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-700',
    green: 'from-green-500 to-green-700',
    purple: 'from-purple-500 to-purple-700',
    red: 'from-red-500 to-red-700',
    yellow: 'from-yellow-500 to-yellow-700',
    indigo: 'from-indigo-500 to-indigo-700'
  };

  const iconColorClasses = {
    blue: 'text-blue-300',
    green: 'text-green-300',
    purple: 'text-purple-300',
    red: 'text-red-300',
    yellow: 'text-yellow-300',
    indigo: 'text-indigo-300'
  };

  return (
    <div
      className={`relative p-6 rounded-2xl shadow-2xl text-white overflow-hidden
                  glass card-hover animate-fadeInUp group cursor-pointer`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Gradient background overlay */}
      <div
        className={`absolute inset-0 bg-gradient-to-br ${colorClasses[color] || colorClasses.blue}
                   opacity-20 group-hover:opacity-30 transition-opacity duration-300`}
      />
      
      {/* Shimmer effect */}
      <div className="absolute inset-0 shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      
      {/* Floating particles effect */}
      <div className="absolute top-2 right-2 w-2 h-2 bg-white rounded-full opacity-20 animate-pulse-slow" />
      <div className="absolute bottom-4 left-4 w-1 h-1 bg-white rounded-full opacity-30 animate-pulse-slow" style={{ animationDelay: '1s' }} />
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm font-medium text-gray-300 uppercase tracking-wider">{title}</p>
          <div className={`text-3xl ${iconColorClasses[color] || iconColorClasses.blue}
                         transform group-hover:scale-110 transition-transform duration-300`}>
            {icon}
          </div>
        </div>
        
        <div className="space-y-2">
          <p className="text-4xl font-bold gradient-text group-hover:scale-105 transition-transform duration-300">
            {value?.toLocaleString() || '0'}
          </p>
          
          {/* Progress bar effect */}
          <div className="w-full bg-gray-700 rounded-full h-1 overflow-hidden">
            <div
              className={`h-full bg-gradient-to-r ${colorClasses[color] || colorClasses.blue}
                         transform scale-x-0 group-hover:scale-x-100 transition-transform duration-700 origin-left`}
            />
          </div>
        </div>
      </div>
      
      {/* Corner accent */}
      <div className={`absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl ${colorClasses[color] || colorClasses.blue}
                     opacity-10 transform rotate-45 translate-x-8 -translate-y-8`} />
    </div>
  );
};

export default StatCard;